import { render, staticRenderFns } from "./AccountsReceivableForm.vue?vue&type=template&id=2ad06369&scoped=true"
import script from "./AccountsReceivableForm.vue?vue&type=script&lang=js"
export * from "./AccountsReceivableForm.vue?vue&type=script&lang=js"
import style0 from "./AccountsReceivableForm.vue?vue&type=style&index=0&id=2ad06369&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad06369",
  null
  
)

export default component.exports